/**
 * API Base URL — environment-aware
 *
 * Staging (staging.plug-n-play-infra.ai) → /v1  → nginx → gunicorn:8001 (staging DB)
 * Prod    (plug-n-play-infra.ai /pnp_main) → /v1  → nginx → gunicorn:8000 (prod DB)
 * Localhost                                → /v1  → local gunicorn:8000
 */
function getApiBase() {
  // Explicit env var override (for local dev or CI)
  if (process.env.REACT_APP_API_BASE) {
    return process.env.REACT_APP_API_BASE;
  }

  // Staging hostname → same /v1 path (nginx on staging host routes to port 8001)
  if (window.location.hostname === 'staging.plug-n-play-infra.ai') {
    return '/v1';
  }

  // Prod and localhost both use /v1
  return '/v1';
}

export const API_BASE = getApiBase();
export default API_BASE;
